export const businessToolFormQueryKeys = {
  businessTools: () => ['businessToolForms'],
  businessTool: (id: string) => [...businessToolFormQueryKeys.businessTools(), id],
};
